import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { CommandItem } from "@/components/ui/command";
import { Stack, Typography } from "@mui/material";
import { Check } from "lucide-react";
import { Customer } from "@/types/customer-type";
import { getInitials } from "./utils/customer-utils";
import { cn } from "@/lib/utils";

interface CustomerListItemProps {
  customer: Customer;
  isSelected: boolean;
  onSelect: () => void;
}

export function CustomerListItem({
  customer,
  isSelected,
  onSelect,
}: CustomerListItemProps) {
  return (
    <CommandItem
      value={String(customer.id)}
      onSelect={onSelect}
      className="flex items-center gap-3 py-2"
    >
      <Check
        className={cn(
          "h-4 w-4",
          isSelected ? "opacity-100 text-emerald-600" : "opacity-0"
        )}
      />
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        sx={{ width: "100%" }}
      >
        <Avatar className="h-8 w-8">
          {customer.profileImageUrl ? (
            <AvatarImage src={customer.profileImageUrl} alt={customer.name} />
          ) : null}
          <AvatarFallback>{getInitials(customer.name)}</AvatarFallback>
        </Avatar>
        <Stack spacing={0} flex={1} minWidth={0}>
          <Typography variant="body2" fontWeight={500} noWrap>
            {customer.name || customer.facebookId || customer.id}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            {customer.email && (
              <Typography variant="caption" color="text.secondary" noWrap>
                {customer.email}
              </Typography>
            )}
            {customer.phone && (
              <Typography variant="caption" color="text.secondary" noWrap>
                {customer.email ? "•" : ""} {customer.phone}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </CommandItem>
  );
}
